import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Firm, User } from '../types/types';
import { RootState } from '../store/store';

const baseUrl = process.env.REACT_APP_Auth0Domain;

interface UserData {
  auth0_id: string;
  site_role: string;
}

export const AuthApi = createApi({
  reducerPath: 'AuthApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://' + `${baseUrl}` + '/',
    prepareHeaders: async (headers, {getState}) => {
      return new Promise(resolve => {
        function checkToken() {
          const token = (getState() as RootState).auth.token;
          if (token) {
            console.log('token = ', token);
            headers.set('Authorization', `Bearer ${token}`)
            resolve(headers)
          } else {
            setTimeout(checkToken, 2000);
          }
        }
        checkToken();
      })
    },
  }),
  endpoints: (builder) => ({
    getUserInfo: builder.query<any, void>({
        query: () => 'userinfo',
    }),
  }),
});

export const { useGetUserInfoQuery } = AuthApi;

export default AuthApi;